import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  CardHeader,
  Alert
} from 'reactstrap';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import SweetAlert from 'react-bootstrap-sweetalert';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { AvForm, AvField } from 'availity-reactstrap-validation';

class LanguagesComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      selLanguage: [],
      alert: null,
      languageModal: false,
      isEdit: false,
      languageColumns: [
        {
          text: 'ID',
          dataField: '_id',
          sort: true,
          editable: false,
          hidden: true,
          formatter: (cell, row, rowIndex) => rowIndex + 1
        },
        {
          text: 'Language',
          dataField: 'lng_name',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, lng) => (
            <h5 className='font-size-16 mb-1 '>
              {lng.lng_name}
            </h5>
          )
        },
        {
          text: 'Code',
          dataField: 'lng_code',
          sort: true,
          csvExport: false,
          hidden: false,
          editable: false,
          formatter: (cellContent, lng) => (
            <h5 className='font-size-16 mb-1 '>{lng.lng_code}</h5>
          )
        },
        {
          dataField: 'menu',
          text: 'Action',
          editable: false,
          formatter: (cellContent, cntr) => (
            <div className='text-center'>
              <Link className='text-success me-2' to='#'>
                <i
                  className='mdi mdi-pencil font-size-18'
                  id='edittooltip'
                  onClick={(e) => this.handleEditLanguage(cntr)}
                ></i>
              </Link>
              <Link className='text-danger' to='#'>
                <i
                  className='mdi mdi-delete font-size-18'
                  id='deletetooltip'
                  onClick={() => this.handleDeleteLanguage(cntr)}
                ></i>
              </Link>
            </div>
          )
        }
      ],
    }
    this.toggleLanguageModal = this.toggleLanguageModal.bind(this);
    this.handleNewLanguage = this.handleNewLanguage.bind(this);
    this.handleEditLanguage = this.handleEditLanguage.bind(this);
    this.checkExistingLanguage = this.checkExistingLanguage.bind(this);
    this.handleSubmitLanguage = this.handleSubmitLanguage.bind(this);
    this.handleDeleteLanguage = this.handleDeleteLanguage.bind(this)
  }
  toggleLanguageModal = () => { this.setState((prevState) => ({ languageModal: !prevState.languageModal })); };
  /**
   * Open modal for new language
   */
  handleNewLanguage = () => {
    this.setState({ selLanguage: [], error: '', isEdit: false });
    this.toggleLanguageModal();
  };
  /**
   * Assign selected language for editing
   * @param {*} language 
   */
  handleEditLanguage = (language) => {
    this.setState({
      selLanguage: {
        _id: language._id,
        lng_code: language.lng_code,
        lng_name: language.lng_name,
      },
      error: '',
      isEdit: true
    });
    this.toggleLanguageModal();
  };
  /**
   * Check if language is already exists in the table
   * @param {array} newLanguage value with new battle invoice No
   * @returns true or false
   */
  checkExistingLanguage = (newLanguage) => {
    const { languages } = this.props.props;
    return languages.some(function (el) {
      return el.lng_name === newLanguage.lng_name;
    });
  };
  /**
   * Submit new language row 
   * @param {*} e 
   * @param {*} values 
   */
  handleSubmitLanguage = (e, values) => {
    const { onAddInfoData, onEditInfoData } = this.props.props;
    const { isEdit, selLanguage } = this.state;
    if (isEdit) {
      const updateLanguage = {
        type: 'languages',
        _id: selLanguage._id,
        lng_code: values.lng_code,
        lng_name: values.lng_name
      }
      onEditInfoData(updateLanguage)
      this.toggleLanguageModal();
    } else {
      const newLanguage = {
        type: 'languages',
        lng_code: values['lng_code'],
        lng_name: values['lng_name']
      }
      if (this.checkExistingLanguage(newLanguage) === true) {
        this.setState({
          error: 'Already exists.'
        });
      } else{
        onAddInfoData(newLanguage)
        this.toggleLanguageModal();
      }
    }
  };
  /**
   * Display delete alert
   * @param {*} language 
   */
  handleDeleteLanguage = (language) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteAlert({type: 'languages', id: language._id})}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };
  /**
   * Delete language row
   * @param {*} data 
   */
  deleteAlert = (data) => {
    const { onDeleteInfoData } = this.props.props;
    onDeleteInfoData(data);
    this.hideAlert();
  };
  /**
   * Hide alert
   * @returns 
   */
  hideAlert = () => this.setState({ alert: null });
  render() {
    const { SearchBar } = Search;
    const { languages } = this.props.props;
    const { languageColumns, languageModal, selLanguage, error, alert, isEdit } = this.state;
    const pageOptions = {
      sizePerPage: languages.length,
      totalSize: languages.length, // replace later with size(users),
      custom: true
    };
    const defaultSorted = [
      {
        dataField: '_id', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];   
    return (
      <React.Fragment>
        <Card>
          <CardBody className='cardBodySticky'>
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField='_id'
              columns={languageColumns}
              data={languages}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField='_id'
                  columns={languageColumns}
                  data={languages}
                  search
                >
                  {(toolkitprops) => (
                    <React.Fragment>
                      <Row className='mb-2'>
                        <Col sm='4'>
                          <div className='search-box ms-2 mt-3 mb-2 d-inline-block'>
                            <div className='position-relative'>
                              <SearchBar {...toolkitprops.searchProps} />
                              <i className='bx bx-search-alt search-icon' />
                            </div>
                          </div>
                        </Col>
                        <Col sm='8' className='text-sm-end'>
                          <Button color='primary' className='mt-2 btn-block btn btn-primary btn-lg' onClick={this.handleNewLanguage}>
                            <i className='mdi mdi-plus-circle-outline me-1' />
                            Add Language
                          </Button>
                          <Modal
                            size='md'
                            isOpen={languageModal}
                            className={this.props.className}
                            toggle={this.toggleLanguageModal}
                          >
                            <ModalHeader toggle={this.toggleLanguageModal} tag='h4'>
                              {!!isEdit ? 'Edit Language' : 'Add Language'}
                            </ModalHeader>
                            <ModalBody>
                              {error !== '' && error ? <Alert color='danger'> {error} </Alert> : null}
                              <AvForm onValidSubmit={this.handleSubmitLanguage}>
                                <Row>
                                  <Col md={6}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        name='lng_name'
                                        label='Language'
                                        value={selLanguage.lng_name || ''}
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup className='mb-3'>
                                      <AvField
                                        name='lng_code'
                                        label='Code'
                                        value={selLanguage.lng_code || ''}
                                        validate={{
                                          required: {
                                            value: true
                                          }
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className='text-end'>
                                      <button
                                        type='submit'
                                        className='btn btn-success save-user'
                                      >
                                        {!!isEdit
                                          ? 'Edit Language'
                                          : 'Add Language'}
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </AvForm>
                            </ModalBody>
                          </Modal>
                        </Col>
                      </Row>
                      <Row id='table-section'>
                        <BootstrapTable
                          {...toolkitprops.baseProps}
                          {...paginationTableProps}
                          defaultSorted={defaultSorted}
                          classes={
                            'table align-middle text-center table-nowrap'
                          }
                          headerClasses='header-class is-sticky-hdr'
                          id='tableScroll'
                          bordered={true}
                          // striped={true}
                          responsive
                        />
                        {alert}
                      </Row>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

LanguagesComp.propTypes = {

};

const mapStateToProps = ({ state }) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LanguagesComp));